import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useQuote } from "@/context/QuoteContext";
import { useLang } from "@/i18n/LanguageContext";
import { PiggyBank, X } from "lucide-react";

export default function ExitIntent() {
  const { openQuote } = useQuote();
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("mgd_exit_shown")) return;
    if (window.matchMedia("(max-width: 767px)").matches) return; // desktop only
    const onLeave = (e) => {
      if (e.clientY <= 0) {
        sessionStorage.setItem("mgd_exit_shown", "1");
        setOpen(true);
        document.removeEventListener("mouseout", onLeave);
      }
    };
    const timer = setTimeout(() => document.addEventListener("mouseout", onLeave), 6000);
    return () => { clearTimeout(timer); document.removeEventListener("mouseout", onLeave); };
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md text-center p-0 overflow-hidden" data-testid="exit-intent-dialog">
        <div className="bg-primary text-primary-foreground p-8 pb-6">
          <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center mx-auto mb-3">
            <PiggyBank className="w-7 h-7" />
          </div>
          <DialogTitle className="font-heading text-2xl font-extrabold text-white">{t("exit.title")}</DialogTitle>
          <p className="text-white/80 text-sm mt-2">{t("exit.sub")}</p>
        </div>
        <div className="p-6 pt-5">
          <Button className="w-full rounded-full h-12" onClick={() => { setOpen(false); openQuote({ type: "quote" }); }} data-testid="exit-intent-cta">
            {t("exit.cta")}
          </Button>
          <button className="mt-3 text-xs text-muted-foreground hover:text-foreground flex items-center gap-1 mx-auto" onClick={() => setOpen(false)} data-testid="exit-intent-dismiss">
            <X className="w-3 h-3" /> {t("exit.dismiss")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
